import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import classList from 'flarum/common/utils/classList';
/**
 * The whole ladder as one picture: a card per rank, in its colour, with its
 * artwork (or its icon, when it has none) and the posts it takes.
 *
 * Drawn from the ladder every time rather than exported as an image, so it is
 * never out of date, stays sharp at any size, and reads in any language.
 */
export default class LadderBanner extends Component {
  view() {
    const {
      ladder,
      currentGroupId
    } = this.attrs;
    const title = ladder.banner.title || app.forum.attribute('title');
    return m("div", {
      className: "LadderBanner"
    }, m("div", {
      className: "LadderBanner-head"
    }, m("span", {
      className: "LadderBanner-rule",
      "aria-hidden": "true"
    }), m("div", {
      className: "LadderBanner-titles"
    }, m("h2", {
      className: "LadderBanner-title"
    }, title), ladder.banner.tagline && m("p", {
      className: "LadderBanner-tagline"
    }, ladder.banner.tagline)), m("span", {
      className: "LadderBanner-rule",
      "aria-hidden": "true"
    })), m("ol", {
      className: "LadderBanner-cards",
      style: {
        '--ladder-count': ladder.rungs.length
      }
    }, ladder.rungs.map(rung => this.card(rung, rung.groupId === currentGroupId))));
  }
  card(rung, isMine) {
    const color = rung.color || 'var(--primary-color)';
    const range = rung.maxPosts === null ? app.translator.trans('ernestdefoe-ladder.lib.banner.range_open', {
      min: rung.minPosts
    }) : app.translator.trans('ernestdefoe-ladder.lib.banner.range', {
      min: rung.minPosts,
      max: rung.maxPosts
    });
    return m("li", {
      className: classList('LadderBanner-card', isMine && 'LadderBanner-card--mine'),
      style: {
        '--ladder-color': color
      }
    }, m("div", {
      className: classList('LadderBanner-name', rung.color && textContrastClass(rung.color))
      // Long names shrink to fit their card instead of being cut short:
      // about ten capitals fit at full size, so a 13-letter rank is
      // drawn at ten-thirteenths of it.
      ,
      style: {
        '--ladder-fit': Math.min(1, 10 / Math.max(1, rung.name.length)).toFixed(3)
      }
    }, rung.name), m("div", {
      className: classList('LadderBanner-art', !rung.imageUrl && 'LadderBanner-art--icon')
    }, rung.imageUrl ? m("img", {
      src: rung.imageUrl,
      alt: "",
      loading: "lazy"
    }) : m(Icon, {
      name: rung.icon || 'fas fa-star',
      className: "LadderBanner-icon"
    })), m("div", {
      className: "LadderBanner-range"
    }, range));
  }
}
flarum.reg.add('ernestdefoe-ladder', 'common/components/LadderBanner', LadderBanner);